import React from 'react';
import { AlertTriangle, Settings } from 'lucide-react';
import './AdminConfigWarning.css';

/**
 * AdminConfigWarning component
 * Displays a warning when admin functionality is not properly configured
 */
const AdminConfigWarning = ({ onRetry }) => {
  return (
    <div className="admin-config-warning">
      <div className="warning-icon">
        <AlertTriangle size={48} />
      </div>
      <h2>Admin Configuration Required</h2>
      <div className="warning-content">
        <p>
          The admin panel requires a secure backend server to function properly. 
          All admin operations are now handled server-side for security.
        </p>
        
        <div className="config-steps">
          <h3>Setup Instructions:</h3>
          <ol>
            <li>
              <strong>Start the backend server:</strong>
              <ul>
                <li>Open a terminal in the project directory</li>
                <li>Run: <code>cd server</code></li>
                <li>Run: <code>npm start</code></li>
                <li>Verify it starts on port 3001</li>
              </ul>
            </li>
            <li>
              <strong>Verify server configuration:</strong>
              <ul>
                <li>Ensure <code>server/.env</code> exists with proper configuration</li>
                <li>Service role key should ONLY be in server environment</li>
                <li>Never expose service role key in client code</li>
              </ul>
            </li>
            <li>
              <strong>Test the connection:</strong>
              <ul>
                <li>Check if <code>http://localhost:3001/api/health</code> responds</li>
                <li>Refresh this page to retry admin functionality</li>
              </ul>
            </li>
          </ol>
        </div>

        <div className="warning-note">
          <Settings size={20} />
          <div>
            <strong>Security Note:</strong> Never commit the service role key to version control. 
            Keep it in your <code>.env</code> file and ensure <code>.env</code> is in your <code>.gitignore</code>.
          </div>
        </div>

        {onRetry && (
          <button onClick={onRetry} className="retry-button">
            Try Again
          </button>
        )}
      </div>
    </div>
  );
};

export default AdminConfigWarning;